import { PortalError } from './PortalError';

export class NotRenderedReportError extends PortalError {
  constructor(reportId?: string) {
    super('NotRenderedReportError', `Report ${reportId} not rendered`, 'pdf_download_error');
  }
}
